import { useAtomValue } from "jotai";
import { optimizationBatchAtom } from "@/store/optimizationBatch";
import { useTranslation } from "react-i18next";

export function OptimizationProgressBanner() {
  const batch = useAtomValue(optimizationBatchAtom);
  const { t } = useTranslation();

  if (!batch) return null;

  const pct =
    batch.total > 0 ? Math.round((batch.done / batch.total) * 100) : 0;

  return (
    // BUG-420: the running tone follows the tenant's `brand-primary` token (set
    // at runtime by BrandProvider) rather than a hardcoded blue — on a
    // white-label dealer domain a fixed blue reads as someone else's product.
    <div
      data-testid="optimization-progress-banner"
      className="flex items-center gap-3 rounded-b-none rounded-t-none border-b border-brand-primary/20 bg-brand-primary/5 px-6 py-2 text-sm text-brand-primary"
    >
      <svg
        className="h-4 w-4 shrink-0 animate-spin text-brand-primary"
        viewBox="0 0 24 24"
        fill="none"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
        />
      </svg>
      <span className="font-medium">
        {t("optimization.recalculating", {
          done: batch.done,
          total: batch.total,
          defaultValue: "Recalculating routes: {{done}} / {{total}}",
        })}
      </span>
      <div className="flex-1">
        <div className="h-1.5 w-full overflow-hidden rounded-full bg-brand-primary/20">
          <div
            data-testid="optimization-progress-bar"
            className="h-full rounded-full bg-brand-primary transition-all duration-300"
            style={{ width: `${pct}%` }}
          />
        </div>
      </div>
      <span className="shrink-0 tabular-nums">{pct}%</span>
    </div>
  );
}
